import { render, staticRenderFns } from "./LoginRedirect.vue?vue&type=template&id=e766b926&scoped=true&"
import script from "./LoginRedirect.vue?vue&type=script&lang=js&"
export * from "./LoginRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e766b926",
  null
  
)

/* custom blocks */
import block0 from "./LoginRedirect.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports